<script lang="ts">
  import { fn } from "../../../stores";
  import type{ TRichAlertButtonConfig, TRichAlertOptions } from "../../../utils/types";
  import { get } from "svelte/store";

  export let options: TRichAlertOptions;

  let title: string | undefined;
  let description: string | undefined;
  let action: TRichAlertButtonConfig | undefined;
  const { close } = get(fn);

  $: if (options) {
    ({ title, description, action } = options);
  }

  const btnClass = `crtw-px-[36px] crtw-flex crtw-justify-center crtw-items-center crtw-bg-black crtw-text-white crtw-h-[50px] crtw-cursor-pointer
      crtw-border-0 crtw-rounded crtw-font-['Poppins'] crtw-text-sm crtw-font-medium`
</script>

<div class="crtw-flex crtw-flex-col crtw-justify-start crtw-items-start crtw-w-full crtw-mx-[50px]">
  <div class="crtw-flex crtw-flex-col crtw-justify-start crtw-items-start crtw-font-['Poppins'] crtw-w-full crtw-mt-[36px]">
    <span class="crtw-text-[24px] crtw-text-[#313a2c] crtw-font-medium">
      {title}
    </span>

    <span class="crtw-text-base crtw-text-[#747474] crtw-mb-1">
      {description}
    </span>
  </div>

  <div class="crtw-flex crtw-flex crtw-gap-[6px] crtw-w-full crtw-items-center crtw-mb-[100px] crtw-mt-[30px]">
    {#if action}
      {#if action?.onClick}
        <button class={btnClass} on:click={action.onClick}> {action.text}</button>
      {:else if action?.link}
        <a
          href={action?.link}
          class="crtw-flex crtw-justify-center crtw-items-center crtw-w-full crtw-h-[50px] crtw-cursor-pointer
          crtw-border-2 crtw-border-black crtw-rounded crtw-font-['Poppins'] crtw-text-base crtw-font-medium"
          >{action?.text}
        </a>
      {/if}
    {/if}

    <button class={btnClass} on:click={close}>{options.closeButtonText || "Close"}</button>
  </div>
</div>
